import { render, staticRenderFns } from "./NotificationPanelList.vue?vue&type=template&id=3a563abc&scoped=true&"
import script from "./NotificationPanelList.vue?vue&type=script&lang=js&"
export * from "./NotificationPanelList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPanelList.vue?vue&type=style&index=0&id=3a563abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a563abc",
  null
  
)

export default component.exports